import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

const baseName = String(import.meta.env.VITE_APP_BASE || '').replace(/\/$/, '');
const faviconFile = import.meta.env.VITE_COMPANY_FAVICON;
const faviconFolder = 'favicon/';

if (faviconFile) {
    const favicon = document.querySelector("link[rel~='icon']");
    if (favicon) {
        favicon.href = faviconFile;
    }
}


ReactDOM.createRoot(document.getElementById("root")).render(
    <BrowserRouter basename={baseName}>
        <AuthProvider>
            <App />
        </AuthProvider>
    </BrowserRouter>
);